import React from 'react';
import ComingSoon from '../../Components/comingSoon';

function StupidDesigns() {
  return <ComingSoon />;
}

export default StupidDesigns; 